import { render, staticRenderFns } from "./ModalAddDocument.vue?vue&type=template&id=4d9d1664&scoped=true&"
import script from "./ModalAddDocument.vue?vue&type=script&lang=js&"
export * from "./ModalAddDocument.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddDocument.vue?vue&type=style&index=0&id=4d9d1664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9d1664",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
